import { HOTKEY_SCOPES } from 'lib/constants';
import { useHotkeys } from 'react-hotkeys-hook';

type InsightsHotkeysOptions = Exclude<
  Parameters<typeof useHotkeys>[2],
  undefined
> & {
  scopes: HOTKEY_SCOPES;
};

type UHParams = Parameters<typeof useHotkeys>;
type InsightsHotkeysParams = [
  keys: UHParams[0],
  callback: UHParams[1],
  options?: InsightsHotkeysOptions,
  dependencies?: UHParams[3],
];

export const useInsightsHotkeys = (...args: InsightsHotkeysParams) => {
  return useHotkeys(...args);
};
